import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import SecureLS from "secure-ls";
import StoreTitle from "../../component/StoreTitle";

const ls = new SecureLS({ encodingType: "aes" });

const AccountHero = ({ title }) => {
  const navigate = useNavigate();
  const user = ls.get("user");
  const modules = user?.modules || [];
  const role = user?.role || "";

  const isOtpRole =
    modules.some((m) =>
      ["OTPGeneration", "OTP Generation", "Superadmin"].includes(m)
    ) || ["OTPGeneration", "OTP Generation", "Superadmin"].includes(role);

  const isTogglesRole =
    modules.some((m) =>
      ["ToggleFeatures", "Toggle Features", "Superadmin"].includes(m)
    ) || ["ToggleFeatures", "Toggle Features", "Superadmin"].includes(role);

  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/dashboard")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>
      <Box sx={{ marginTop: -8 }}>
        <StoreTitle title="Account Management" />
      </Box>
      {(isOtpRole || isTogglesRole) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 4,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate("/account-management")}
          >
            Profile
          </Button>

          {isTogglesRole && (
            <Button
              variant="outlined"
              onClick={() => navigate("/account-management/toggles")}
            >
              Toggles
            </Button>
          )}

          {isOtpRole && (
            <Button
              variant="outlined"
              onClick={() => navigate("/account-management/otps")}
            >
              OTPs
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default AccountHero;
